import React from 'react';
import PropTypes from 'prop-types';

import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import SkuMenuSection from './SkuMenuSection';

import './SkuAllMenusOverview.scss';

const { block } = bem('sku-all-menus-overview');

const SkuAllMenusOverview = ({
  menus,
  noCategoriesMessage,
  hideMenuTitle = false,
  currencyCode,
  collapseStorageKey,
  onAddItem,
  onEditItem,
  onDeleteItem,
  onEditCategory,
  onDuplicateCategory,
  onToggleCategory,
  onDeleteCategory,
  onStatusChange,
  onViewItem,
  onViewCategory,
}) => {
  return (
    <div className={block()}>
      {menus.map(menu => (
        <SkuMenuSection
          key={menu.id}
          menu={menu}
          noCategoriesMessage={noCategoriesMessage}
          hideMenuTitle={hideMenuTitle}
          currencyCode={currencyCode}
          collapseStorageKey={collapseStorageKey}
          onAddItem={onAddItem}
          onEditItem={onEditItem}
          onDeleteItem={onDeleteItem}
          onEditCategory={onEditCategory}
          onDuplicateCategory={onDuplicateCategory}
          onToggleCategory={onToggleCategory}
          onDeleteCategory={onDeleteCategory}
          onStatusChange={onStatusChange}
          onViewItem={onViewItem}
          onViewCategory={onViewCategory}
        />
      ))}
    </div>
  );
};

SkuAllMenusOverview.propTypes = {
  menus: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired,
  noCategoriesMessage: intlMessage.isRequired,
  hideMenuTitle: PropTypes.bool,
  currencyCode: PropTypes.string,
  collapseStorageKey: PropTypes.string.isRequired,
  onAddItem: PropTypes.func,
  onEditItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  onEditCategory: PropTypes.func,
  onDuplicateCategory: PropTypes.func,
  onToggleCategory: PropTypes.func,
  onDeleteCategory: PropTypes.func,
  onStatusChange: PropTypes.func,
  onViewItem: PropTypes.func,
  onViewCategory: PropTypes.func,
};

export default SkuAllMenusOverview;
